export enum UserTypeNameEnum {
    Investor = 'investor',
    Sponsor = 'sponsor',
    LocationOwner = 'location-owner',
    Affiliate = 'affiliate',
    Advertiser = 'advertiser',
    Broker = 'broker',
    SponsorAgent = 'sponsor-agent',
    LocationAgent = 'location-agent',
    AdvertiserAgent = 'advertiser-agent',
    Ab = 'Ab',
    Bb ='Bb',
    Buffer = 'Buffer',
}

export enum UserTypeName {
    Investor = 'Investor',
    Sponsor = 'Sponsor',
    LocationOwner = 'Location owner',
    Affiliate = 'Affiliate',
    Advertiser = 'Advertiser',
    Broker = 'Broker',
    SponsorAgent = 'Sponsor agent',
    LocationAgent = 'Location agent',
    AdvertiserAgent = 'Advertiser agent',
    Ab = 'Ab',
    Bb = 'Bb',
    Buffer = 'Buffer',
}
